import _ChevronRight from "@mui/icons-material/ChevronRight";
import _Box from "@mui/material/Box";
import _Typography from "@mui/material/Typography";
import _Button2 from "@mui/material/Button";
import React from 'react';
import { useTranslation } from 'react-i18next';
const ICON_SIZE = 40;
function BfgHowItWorksCard({
  Button: _Button,
  onFaqClick
}) {
  const {
    t
  } = useTranslation();
  const Button = _Button || _Button2;
  const steps = [{
    emoji: '🚴🏻‍♂️',
    title: t('commons.challenges.bfg_faq.how_it_works.step_points_title'),
    description: t('commons.challenges.bfg_faq.how_it_works.step_points_description'),
    color: '#F3F6FF'
  }, {
    emoji: '🗺️',
    title: t('commons.challenges.bfg_faq.how_it_works.step_exploration_title'),
    description: t('commons.challenges.bfg_faq.how_it_works.step_exploration_description'),
    color: '#ECFBF4'
  }, {
    emoji: '🏆',
    title: t('commons.challenges.bfg_faq.how_it_works.step_ranking_title'),
    description: t('commons.challenges.bfg_faq.how_it_works.step_ranking_description'),
    color: '#FFEEE0'
  }, {
    emoji: '🎁',
    title: t('commons.challenges.bfg_faq.how_it_works.step_lottery_title'),
    description: t('commons.challenges.bfg_faq.how_it_works.step_lottery_description'),
    color: '#FFF5D0'
  }];
  return /*#__PURE__*/React.createElement(_Box, {
    bgcolor: "#fff",
    border: "1px solid #D9E7FF",
    borderRadius: 4,
    display: "flex",
    flexDirection: "column",
    gap: 4,
    paddingX: 4,
    paddingY: 5
  }, /*#__PURE__*/React.createElement(_Typography, {
    sx: {
      fontSize: 20,
      fontWeight: 700
    }
  }, t('commons.challenges.bfg_faq.how_it_works.title')), /*#__PURE__*/React.createElement(_Box, {
    display: "flex",
    flexDirection: "column",
    gap: 3
  }, steps.map(({
    emoji,
    title,
    description,
    color
  }) => /*#__PURE__*/React.createElement(_Box, {
    alignItems: "center",
    display: "flex",
    gap: 3,
    key: title
  }, /*#__PURE__*/React.createElement(_Box, {
    alignItems: "center",
    borderRadius: 2,
    display: "flex",
    flexShrink: 0,
    height: ICON_SIZE,
    justifyContent: "center",
    sx: {
      bgcolor: color,
      boxShadow: '0px 4px 7px rgba(6,78,59,0.08)',
      fontSize: 24
    },
    width: ICON_SIZE
  }, emoji), /*#__PURE__*/React.createElement(_Box, {
    display: "flex",
    flexDirection: "column"
  }, /*#__PURE__*/React.createElement(_Typography, {
    sx: {
      fontSize: 16,
      fontWeight: 700,
      lineHeight: 1.6
    }
  }, title), /*#__PURE__*/React.createElement(_Typography, {
    color: "textSecondary",
    sx: {
      fontSize: 14,
      fontWeight: 400,
      lineHeight: 1.5
    }
  }, description))))), /*#__PURE__*/React.createElement(_Box, null, /*#__PURE__*/React.createElement(Button, {
    color: "primary",
    endIcon: /*#__PURE__*/React.createElement(_ChevronRight, null),
    onClick: onFaqClick,
    variant: "contained"
  }, t('commons.challenges.bfg_faq.how_it_works.faq_action'))));
}
export default BfgHowItWorksCard;